import React from "react";
import { Provider } from "react-redux";
import appStore from "bundles/common/store/appStore";
import InternalContainer from "bundles/Internal/container/InternalContainer";
import InternalTheme from "bundles/Layouts/InternalTheme";
import { SnackbarProvider } from "notistack";

const InternalApp = (props, railsContext) => {
  return (
    <Provider store={appStore(Object.assign(railsContext, props))}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <InternalTheme>
          <InternalContainer {...props} />
        </InternalTheme>
      </SnackbarProvider>
    </Provider>
  );
};

export default InternalApp;
